// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"48":"51a364d1","453":"3fc3859d","455":"0c919363","977":"164e3e68"}[chunkId] + ".chunk.js";
};